var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTask = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 23.571, height: 30 }, props, { children: [_jsx("path", { "data-name": "Path 231", d: "m9.643 19.479-3.846-3.846-1.511 1.51L9.643 22.5l9.643-9.643-1.511-1.521Z" }), _jsx("path", { "data-name": "Path 232", d: "M21.429 3.214h-3.215V2.143A2.143 2.143 0 0 0 16.071 0H7.5a2.143 2.143 0 0 0-2.143 2.143v1.071H2.143A2.143 2.143 0 0 0 0 5.357v22.5A2.143 2.143 0 0 0 2.143 30h19.286a2.143 2.143 0 0 0 2.143-2.143v-22.5a2.143 2.143 0 0 0-2.143-2.143ZM7.5 2.143h8.571v4.286H7.5Zm13.929 25.714H2.143v-22.5h3.214v3.214h12.857V5.357h3.214Z" })] }))); };
export default SvgTask;
